export type UnionsEnvironment = 'cordova' | 'bot' | 'ios' | 'android' | 'mobile' | 'default';

export type DownloadFileDefinition = {
  src?: string;
  fileName?: string;
  data?: Blob | string;
};
